/* eslint-disable */

import Links from "./components/Links";
import logo from "assets/img/logo/evoroads_logo.svg";
import routes from "routes.js";
import { useState } from "react";
import { useAuth } from "contexts/AuthContext";
import { API_URL } from "config/api";
import { getSidebarRoutes } from "utils/routeAccess";

const Sidebar = ({ open, onClose }) => {
  const [healthStatus, setHealthStatus] = useState(null);
  const { user } = useAuth();

  // Shared with layouts/admin so the menu and the registered routes cannot drift.
  const visibleRoutes = getSidebarRoutes(routes, "app", user);

  const testHealth = async () => {
    try {
      const response = await fetch(`${API_URL}/health`);

      if (!response.ok) {
        throw new Error("Health check failed");
      }

      const data = await response.json();
      console.log("Health response:", data);
      setHealthStatus("Backend is healthy ✅");
    } catch (error) {
      console.error("Health error:", error);
      setHealthStatus("Backend not reachable ❌");
    }
  };

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white  shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "-translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute right-4 top-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      ></span>

      <div className="mx-[20px] mt-[50px] flex items-center">
        <img src={logo} alt="EvoRoads" style={{ height: 44 }} />
      </div>
      <div class="mb-7 mt-[58px] h-px bg-gray-300 dark:bg-white/30" />
      <ul className="mb-auto pt-1">
        <Links routes={visibleRoutes} />
      </ul>
      <div className="p-4">
        <button
          onClick={testHealth}
          className="w-full rounded-lg bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700"
        >
          Test Backend Health
        </button>

        {healthStatus && (
          <p className="mt-3 text-center text-sm">{healthStatus}</p>
        )}
      </div>
      <div className="flex justify-center">{/* <SidebarCard /> */}</div>

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
